import React from 'react';
import { Link } from 'react-router-dom';
import './css/index.scss';

class Terms extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      
    };
  }
  
  componentDidMount(){
    window.scrollTo(0, 0);
    document.title = "Taburi.ro - Pagină inexistentă";
  }

  componentWillUnmount(){
    document.title = "Taburi.ro - Tabulaturi pentru chitară, pian și alte instrumente";
  }

  render () {
    return (
      <div className="notFoundContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-200px'}}>
            <h1>Această pagină nu a fost găsită!</h1>
            <div>
                <p>Încercați să folosiți bara de căutare de mai sus sau să navigați pe <Link to="/">prima pagină</Link>.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/notFound/notFound.js